import React from 'react';
import { createIcon } from './create-icon';
import './icon-chevron-down.scss';

export const IconChevronDown = createIcon(<div className="icon-chevron-down" />);
